/* globals window document */
import { getMembershipType, getCheckoutFlow } from '../utils';

const {
  env,
  language,
  country,
  isLoggedIn,
  memberId,
  cities,
  membershipSettings,
  notificationPreferences,
} = window.appSettings;
const selectedCity = cities.find(c => c.city_code === window.selectedCity);
const selectedCountryProduct = membershipSettings && membershipSettings.city && cities
  .find(c => c.name === membershipSettings.city).country_code;

function setMembershipData(dataLayer) {
  dataLayer.membership_city = membershipSettings.city.toLowerCase();
  dataLayer.membership_country = selectedCountryProduct.toLowerCase();
  dataLayer.membership_plan = membershipSettings.plan.toLowerCase();
  dataLayer.membership_status = membershipSettings.status;
  dataLayer.membership_b2b_type = getMembershipType(membershipSettings.type);
}

function setNotificationData(dataLayer) {
  dataLayer.notifications = {
    booking_information: notificationPreferences.categories.reservation,
    review_invites: notificationPreferences.categories.review,
    newsletter: notificationPreferences.categories.commercial,
    booking_reminders: notificationPreferences.categories.reservation,
    friends: notificationPreferences.categories.friend,
    payment_update: notificationPreferences.categories.payment,
  };
}

const pageView = (data) => {
  const dataLayer = {
    event: 'page_viewed',
    environment: env,
    language,
    country,
    type: data.pageCategory,
    referrer: document.referrer,
    user: {
      login_status: 'logged-out',
      id: '',
    },
  };

  if (selectedCity) {
    dataLayer.city = selectedCity.name.toLowerCase();
  }

  if (data.checkoutFlow) {
    dataLayer.checkout_flow = getCheckoutFlow(data.productCategory);
  }

  if (isLoggedIn) {
    const customerDataLayer = {
      login_status: 'logged-in',
      id: memberId,
      cluster: '',
    };

    if (membershipSettings) {
      setMembershipData(customerDataLayer);
    }

    dataLayer.user = {
      ...dataLayer.user,
      ...customerDataLayer,
    };
  }

  if (data.venue) {
    dataLayer.venue = {
      ...data.venue,
    };
  }

  if (notificationPreferences) {
    setNotificationData(dataLayer);
  }

  if (data.class) {
    dataLayer.class = {
      ...data.class,
    };
  }

  return dataLayer;
};

export default pageView;



// WEBPACK FOOTER //
// ./resources/assets/js/components/eventTracker/dataLayer/pageView.js